import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { find } from 'lodash-es'
import { useQuery } from '@tanstack/react-query'
import { getElementLoads } from '@queries'
import useSlabIconFromCenter from './useSlabIconFromCenter'

interface Arguments {
  slab: ShapeObject
  offset?: number
  offsetX?: number
}

const useManualLoadAssignment = ({ slab, offset = 0.05, offsetX = 0.3 }: Arguments) => {
  const { projectId }: { projectId?: string } = useParams()
  const { data: elementLoadsData } = useQuery(getElementLoads.getKey(projectId), () =>
    getElementLoads.request(projectId),
  ) as { isFetching: boolean; data?: ElementLoad[] }

  const { pointForIcon, rotation } = useSlabIconFromCenter(slab, {
    offsetZ: offset,
    iconSizeX: 0.15,
    iconSizeY: 0.15,
    offsetX,
  })

  return useMemo(() => {
    const hasManualLoad = !!find(elementLoadsData, { element_guid: slab.guid })

    return {
      hasManualLoad: hasManualLoad,
      pointForIcon,
      rotation,
    }
  }, [elementLoadsData, slab.guid, pointForIcon, rotation])
}

export default useManualLoadAssignment
